import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';

import { CMSFacade } from 'ish-core/facades/cms.facade';
import { IconModule } from 'ish-core/icon.module';
import { ContentPageletEntryPointView, ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { DesignViewService } from 'ish-core/utils/design-view/design-view.service';
import { PreviewService } from 'ish-core/utils/preview/preview.service';

@Component({
  selector: 'ish-content-design-view-wrapper',
  templateUrl: './content-design-view-wrapper.component.html',
  styleUrls: ['./content-design-view-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconModule, TranslateModule],
})
export class ContentDesignViewWrapperComponent implements OnInit {
  private cmsFacade = inject(CMSFacade);
  private previewService = inject(PreviewService);
  private designViewService = inject(DesignViewService);

  // pagelet parameter
  readonly pageletId = input<string>(undefined);
  // slot parameters
  readonly slotId = input<string>(undefined);
  readonly pagelet = input<ContentPageletView>(undefined);
  // include parameter
  readonly include = input<ContentPageletEntryPointView>(undefined);
  isPageletSelected$: Observable<boolean>;

  pagelet$: Observable<ContentPageletView>;
  type: 'pagelet' | 'slot' | 'include';

  isDesignViewMode = false;

  ngOnInit() {
    this.isDesignViewMode = this.previewService.isDesignViewMode;

    const pageletId = this.pageletId();
    if (pageletId) {
      this.type = 'pagelet';
      this.pagelet$ = this.cmsFacade.pagelet$(pageletId);

      this.isPageletSelected$ = this.cmsFacade.designViewSelectedPageletId$.pipe(
        map(id => (this.isDesignViewMode ? this.pageletId() === id : false))
      );
    } else if (this.slotId()) {
      this.type = 'slot';
    } else if (this.include()) {
      this.type = 'include';
    }
  }

  triggerAction(id: string, action: string) {
    this.designViewService.messageToHost({ type: 'dv-clientAction', payload: { id, action } });
  }
}
